import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { CalendarBookingSettings } from '../../models/serializable/calendar-booking-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class CalendarBookingSettingsComponent extends Component {
  static readonly TYPE_ID: string = 'ed6e0bce01f84c3fbf67a8dd4279b234';

  constructor(
    public readonly settings: CalendarBookingSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return CalendarBookingSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CalendarBookingSettingsComponent {
    return new CalendarBookingSettingsComponent(
        context.fromData<CalendarBookingSettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new CalendarBookingSettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: CalendarBookingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class CalendarBookingSettingsComponentBuilder extends DataModelBuilder<CalendarBookingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): CalendarBookingSettingsComponent {
    return CalendarBookingSettingsComponent.fromMap(context, map);
  }
}
